import React from 'react'
import PropTypes from 'prop-types'
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { Visibility, VisibilityOff } from 'icons'

import styles from './EditTextField.style'

class EditTextField extends React.PureComponent {
  state = {
    showPassword: false,
  }

  handleClickShowPassword=() => {
    const {
      showPassword,
    } = this.state
    this.setState({ showPassword: !showPassword })
  }

  createAdorment =() => {
    const {
      showPassword,
    } = this.state
    const {
      classes,
    } = this.props
    return (
      <InputAdornment position="end">
        <IconButton
          aria-label="Toggle password visibility"
          onClick={this.handleClickShowPassword}
          size="large"
        >
          {showPassword ? <Visibility className={classes.icon} /> : <VisibilityOff className={classes.icon} />}
        </IconButton>
      </InputAdornment>
    )
  }

  createTextField =() => {
    const {
      showPassword,
    } = this.state
    const {
      input,
      placeholder,
    } = this.props
    return (
      <TextField
        variant="standard"
        type={showPassword ? 'text' : 'password'}
        onChange={(event, index, value) => input.onChange(value)}
        InputProps={{
          endAdornment: this.createAdorment(),
          placeholder,
          ...input,
        }}
      />
    )
  }

  hintControl =() => {
    const {
      hint,
    } = this.props
    if (hint) {
      return (
        <Tooltip title={hint}>{this.createTextField()}</Tooltip>
      )
    }
    return (
      this.createTextField()
    )
  }

  render() {
    const {
      meta: { touched, error },
      classes,
    } = this.props
    return (
      <FormControl variant="standard" className={classes.input}>
        {this.hintControl()}
        {touched && error && (
          <FormHelperText id="component-error-text" className={classes.text}>
            {error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

EditTextField.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }).isRequired,
  hint: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
}

EditTextField.defaultProps = {
  hint: null,
}

export default (withStyles(EditTextField, styles))
